export const IFRAME_ERROR_SPREEDLY = 'IFrameErrorSpreedly';
export const SPREEDLY_ERROR = 'SpreedlyError';
export const TIMEKIT_BOOKING_ERROR_MESSAGE = 'Failed to create a booking on Timekit';
